<template>
  <v-container class="wall-container">
    <v-row>
      <!-- Posts Feed -->
      <v-col cols="12" md="8">
        <h1 class="text-h4 mb-4">{{ $t('wall.title') }}</h1>
        <p class="text-subtitle-1 text-grey mb-6">{{ $t('wall.subtitle') }}</p>

        <!-- New Posts Banner -->
        <v-btn
          v-if="newPostsCount > 0"
          color="primary"
          block
          class="mb-4"
          @click="showNewPosts"
        >
          <v-icon start>mdi-arrow-up</v-icon>
          {{ $t('wall.newPosts', { count: newPostsCount }) }}
        </v-btn>

        <!-- Loading -->
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          class="d-block mx-auto my-8"
        ></v-progress-circular>

        <!-- Posts -->
        <div v-else>
          <post-card
            v-for="post in posts"
            :key="post.postId"
            :post="post"
            class="mb-4"
          />

          <v-alert v-if="posts.length === 0" type="info" class="mt-4">
            No posts yet. Be the first to post!
          </v-alert>
        </div>
      </v-col>

      <!-- Post Form Sidebar -->
      <v-col cols="12" md="4">
        <v-card class="post-form-card" elevation="2">
          <v-card-title class="text-h6 bg-primary">
            {{ $t('wall.writePost') }}
          </v-card-title>
          <v-card-text class="pa-4">
            <post-form :autofocus="true" @posted="handleNewPost" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex'
import PostCard from '../components/PostCard.vue'
import PostForm from '../components/PostForm.vue'
import api from '../services/api'

const store = useStore()

const posts = computed(() => store.getters['posts/posts'])
const loading = computed(() => store.getters['posts/loading'])
const newPostsCount = ref(0)

let refreshInterval = null

const loadPosts = () => {
  newPostsCount.value = 0
  store.dispatch('posts/fetchPosts')
}

const checkForNewPosts = async () => {
  if (!posts.value.length) return
  
  try {
    // Get the newest post ID we have
    const newestId = posts.value[0]?.postId
    
    // Check for posts newer than this
    const response = await api.get('/posts', { params: { newerThan: newestId } })
    const newPosts = response.data.posts || []
    
    if (newPosts.length > 0) {
      newPostsCount.value = newPosts.length
    }
  } catch (error) {
    console.debug('Check for new posts failed:', error)
  }
}

const showNewPosts = () => {
  loadPosts()
}

onMounted(() => {
  loadPosts()
  // Check for new posts every 10 seconds
  refreshInterval = setInterval(checkForNewPosts, 10000)
})

onUnmounted(() => {
  if (refreshInterval) {
    clearInterval(refreshInterval)
  }
})

const handleNewPost = () => {
  loadPosts()
}
</script>

<style scoped>
.wall-container {
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 2rem;
}

.post-form-card {
  position: sticky;
  top: 80px;
  max-height: calc(100vh - 96px);
  overflow-y: auto;
}
</style>